<template>
	<div>
		<v-sheet class="mt-10">
			<v-container>
				<v-row>
					<v-col cols="12" md="6">
						<h1 class="orange--text text--darken-2 ff-emkan-bold fs-h3">{{ businessTitle }}</h1>
						<p class="text--primary text-justify line-height-2d5">
							{{ businessTitle }} پلتفرمی است برای اعطای اعتبار برای خرید اقساطی کالا و خدمات که با توجه به مشکلات اقتصادی جامعه شرایطی را برای خرید اقساطی بدون ضامن مهیا کرده. کافی است طرح خرید اقساطی مورد نظر خود را انتخاب کنید و درخواست خود را ثبت کنید و در هر مرحله از ثبت درخواست می توانید سوال یا مشکل خود را با ما درمیان بگذارید و از راهنمایی کارشناسان ما استفاده کنید. {{ businessTitle }} آماده همکاری با فروشگاه ها و سازمان ها می باشد
						</p>
						<v-list dense>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="orange lighten-1" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">خرید اقساطی حتی بدون ضامن</v-list-item-title>
									<v-list-item-title class="fs-h6">بدون ضامن اعتبار خود را دریافت کنید و کالای مورد نظر خود را خرید کنید</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="orange lighten-1" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">بدون نیاز به مراجعه حضوری</v-list-item-title>
									<v-list-item-title class="fs-h6">در هر شهری که هستید میتونید از {{ businessTitle }} خرید اقساطی کنید</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="orange lighten-1" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">اعتبار سنجی سریع</v-list-item-title>
									<v-list-item-title class="fs-h6">مراحل اعتبارسنجی مشتریان عزیز به صورت آنلاین و در کمترین زمان انجام می شود</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
						<div class="text-center mt-4">
							<v-btn class="rounded-xl" color="secondary" elevation="5" @click="scrollToCalculator">
								درخواست خود را ثبت کنید
							</v-btn>
						</div>
					</v-col>
					<v-col cols="12" md="6">
						<v-img src="/choose-us.png" />
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>

		<v-container>
			<v-sheet class="rounded-lg my-10" style="background-color: #36274c;">
				<v-row>
					<v-col cols="12" sm="9" class="secondary" style="border-radius: 50px 20px 20px 50px;padding:14px 30px;background-image: url('/halftone_background_12-2.png')">
						<div class="fs-h3 text-center white--text">
							اگر صاحب کسب و کار هستید و بدنبال تامین کننده هستید، عضو پذیرندگان ما شوید.
						</div>
						<div class="d-flex align-center justify-center mt-2">
							<router-link :to="`/cl/agentregister/${customerCode}`">
								<v-btn color="white" class="rounded-xl" elevation="5">ثبت درخواست پذیرندگی</v-btn>
							</router-link>
						</div>
					</v-col>
					<v-col cols="12" sm="3" style="padding: 20px;display: flex;align-items: center">
						<div class="d-flex align-center w-100" style="width: 100%;">

							<div style="flex-grow:2">
								<div class="fs-h4 text-left white--text">{{ agentOfficePhone }}</div>
								<div class=" text-left white--text">امور نمایندگان</div>
							</div>
							<div class="d-flex align-center pr-2">
								<v-icon color="white" style="padding: 5px;background-color: #101828;border-radius: 8px;">mdi-phone-in-talk-outline</v-icon>
							</div>
						</div>
					</v-col>
				</v-row>

			</v-sheet>
		</v-container>

		<v-sheet color="#f5f5f5" class="py-15 mt-15 px-5">

			<div style="max-width: 750px;" class="mx-auto mb-5">
				<div class="line-title">
					<span class="text">طرح های ما</span>
					<span class="line"></span>
				</div>
				<div class="mt-7 mb-7">
					<div v-if="loanLoading" class="success--text text-h4 text-center">
						در حال دریافت اطلاعات ...
					</div>
					<v-alert outlined dense v-if="loans.length == 0 && !loanLoading" type="error">
						در حال حاضر طرح اعتباری فعالی وجود ندارد
					</v-alert>
					<v-row v-else-if="!loanLoading">
						<v-col cols="12" md="4" v-for="loan in loans" :key="loan.id">
							<v-card elevation="8" class="rounded-xl">
								<div class="text-center pt-5">
									<v-btn fab color="#36274C" elevation="1" x-large>
										<v-icon color="white">mdi-account-cash</v-icon>
									</v-btn>
								</div>
								<div class="fs-h4 text-center" style="height: 110px;padding: 10px;overflow: hidden;">{{ loan.planTitle }}</div>
								<!-- <v-card-text class="justify-center text-center" style="height: ;">{{loan.planShortDescription}}</v-card-text> -->
								<v-card-actions class="text-center justify-center">
									<router-link :to="`/cl/plan/${customerCode}/${loan.code}/${loan.title}`">
										<v-btn class="rounded-xl mb-2" color="secondary" elevation="5">
											اطلاعات بیشتر
										</v-btn>
									</router-link>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" class="text-center">
							<router-link :to="`/cl/ourplans/${customerCode}`">
								<v-btn class="rounded-xl mb-2" color="" elevation="5">
									طرح های ما را کامل تر ببینید
								</v-btn>
							</router-link>
						</v-col>
					</v-row>
				</div>
				<div class="line-title mt-10">
					<span class="text">درخواست خود را ثبت کنید</span>
					<span class="line"></span>
				</div>
				<div class="mt-7">
					<v-row>
						<v-col cols="12" md="6">
							<div class="price-table" style="background-color: #fff">
								<div class="header">
									<div class="title-2">طرح اعتباری مورد نظر خود را انتخاب کنید:</div>
								</div>
								<div class="features">
									<div v-if="loanLoading" class="success--text text-h4 text-center">
										در حال دریافت اطلاعات ...
									</div>
									<v-alert outlined dense v-if="loans.length == 0 && !loanLoading" type="error">
										در حال حاضر طرح اعتباری فعالی وجود ندارد
									</v-alert>
									<div v-else-if="!loanLoading" class="features-item" :class="{ 'secondary--text': loanRequest.loanModel && loanRequest.loanModel.id === loan.id }" v-for="loan in loans" :key="loan.id" @click="selectLoan(loan)">
										<div class="d-flex">
											<v-icon class="ml-1" color="secondary" v-if="loanRequest.loanModel && loanRequest.loanModel.id === loan.id">mdi-check-circle</v-icon>
											<span>{{ loan.planTitle }}</span>
										</div>
										<v-icon>mdi-chevron-left</v-icon>
									</div>
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="6">
							<div class="price-table" style="background-color: #fff">
								<div class="header">
									<div class="title-2">مبلغ اعتبار و تعداد اقساط را انتخاب کنید:</div>
								</div>

								<div class="features">
									<loan-calculator id="calculator" v-model="loanRequest" :payableColor="'orange'" class="mt-3" />
									<div class="mt-5 pb-5 text-center" v-if="loanRequest.loanModel">
										<div v-if="loanRequest.loanModel.disable" class="red--text pa-2">
											{{ loanRequest.loanModel.disableText ? loanRequest.loanModel.disableText : 'این نوع طرح در حال حاضر غیرفعال می باشد.' }}
										</div>
										<v-btn v-else class="rounded-xl" :loading="submitRequestLoading" color="secondary" elevation="5" @click="submitRequest">
											ثبت درخواست
										</v-btn>
									</div>
									<v-alert type="error" outlined v-if="loanRequestMessage">
										{{ loanRequestMessage }}
									</v-alert>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</v-sheet>

		<v-container>
			<v-sheet class="rounded-lg my-10" style="background-color: #36274c;">
				<v-row>
					<v-col cols="12" sm="9" class="secondary" style="border-radius: 50px 20px 20px 50px;padding:14px 30px;background-image: url('/halftone_background_12-2.png')">
						<div class="fs-h3 text-center white--text">
							اگر صاحب کسب و کار هستید و بدنبال تامین کننده هستید، عضو پذیرندگان ما شوید.
						</div>
						<div class="d-flex align-center justify-center mt-2">
							<router-link :to="`/cl/agentregister/${customerCode}`">
								<v-btn color="white" class="rounded-xl" elevation="5">ثبت درخواست پذیرندگی</v-btn>
							</router-link>
						</div>
					</v-col>
					<v-col cols="12" sm="3" style="padding: 20px;display: flex;align-items: center">
						<div class="d-flex align-center w-100" style="width: 100%;">

							<div style="flex-grow:2">
								<div class="fs-h4 text-left white--text">{{ agentOfficePhone }}</div>
								<div class=" text-left white--text">امور نمایندگان</div>
							</div>
							<div class="d-flex align-center pr-2">
								<v-icon color="white" style="padding: 5px;background-color: #101828;border-radius: 8px;">mdi-phone-in-talk-outline</v-icon>
							</div>
						</div>
					</v-col>
				</v-row>

			</v-sheet>
		</v-container>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import router from '@/router'
	import { setCookie, getCookie } from '@/util/helpers'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'PlansView',
		components: {
			'loan-calculator': () => import('@/components/LoanCalculator'),
		},
		data: () => ({
			loanRequest: { amount: 10000000, installmentCount: 1, monthGap: 1, loanModel: null },
			customerCode: 0,
			loans: [],
			loanLoading: false,
			submitRequestLoading: false,
			loanRequestMessage: ''
		}),
		computed: {
			...get('auth', [
				'isMember', 'getCurrentUser'
			]),
			...get('siteConfig', [
				'isCloud', 'fullTitle'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			authorizations() {
				return this.loanRequest.loanModel?.loanAuthorizationItems || []
			},
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
			phone() {
				return this.landingSettings?.phones
			},
			agentOfficePhone() {
				return this.landingSettings?.agentOfficePhone
			}
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			this.loadLoans()
		},
		methods: {
			loadLoans() {
				this.loanLoading = true
				return api.get('loan/list/' + this.customerCode, null, { authHeader: false, contentType: 'application/json' })
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanLoading = false
					})
			},
			submitRequest() {
				if (!this.loanRequest.loanModel) {
					this.loanRequestMessage = 'ابتدا طرح خرید اقساطی را انتخاب کنید.'
					return
				}
				if (!this.isMember) {
					window.localStorage.setItem("loanrequest", JSON.stringify(this.loanRequest))
					router.push({ name: 'Register', params: { customerCode: this.customerCode } }).catch(() => { })
					return
				}
				this.submitRequestLoading = true
				this.loanRequestMessage = ''
				api.post('member/userLoanRequest/create', this.loanRequest)
					.then(response => {
						router.replace('/member/LoanRequest/' + response).catch(() => { })
					})
					.catch(err => {
						this.loanRequestMessage = err.message
					})
					.finally(() => {
						this.submitRequestLoading = false
					})
			},
			selectLoan(loan) {
				this.loanRequest.loanModel = loan
			},
			scrollToCalculator() {
				document.getElementById("calculator").scrollIntoView()
			}
		},
	}
</script>

<style lang="scss">
	.landing {
		.fs-h1 {
			font-size: 3.3125rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 1.0625rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}
	}

	.section-title {
		position: relative;
		margin-right: 38px;

		&:before {
			position: absolute;
			bottom: 5px;
			right: -40px;
			content: "";
			width: 30px;
			height: 60px;
			background-image: radial-gradient(#bbb 2px, transparent 2px);
			-webkit-background-size: 20px 20px;
			background-size: 10px 10px;
			border-radius: 0px;
			background-repeat: initial;
		}
	}

	.line-title {
		position: relative;
		display: flex;

		.line {
			position: relative;
			flex-grow: 2;

			&:after {
				position: absolute;
				content: " ";
				background-color: #cdcdcd47;
				height: 2px;
				right: 0;
				left: 0;
				top: 25px;
			}
		}

		.text {
			padding-left: 20px;
			font-size: 2.25rem !important;
			color: orange;
			font-family: "Emkan-Bold", "Yekan", "tahoma";
		}

		&:after {
			height: 2px;
			width: 50px;
			content: "";
			position: absolute;
			left: 0;
			height: 2px;
			top: 46%;
			background-color: orange;
		}
	}

	.price-table {
		background-color: #f1f1f1;
		position: relative;

		.price-table__ribbon {
			position: absolute;
			top: 0;
			left: 0;
			right: auto;
			-webkit-transform: rotate(0);
			-ms-transform: rotate(0);
			transform: rotate(0);
			width: 150px;
			overflow: hidden;
			height: 150px;

			.price-table__ribbon-inner {
				background-color: orange;
				color: #ffffff;
				font-weight: 500;
				text-align: center;
				left: 0;
				width: 200%;
				-webkit-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				-ms-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				margin-top: 35px;
				font-size: 13px;
				line-height: 2;
			}
		}

		.header {
			background-color: #4d306e;
			text-align: center;
			padding: 20px;

			.title-1 {
				font-size: 1.4rem;
				font-weight: bold;
				color: white;
			}

			.title-2 {
				font-size: 0.9rem;
				color: white;
			}
		}

		.price {
			padding: 15px;
			// font-family: "Emkan-Bold", "Yekan", "tahoma";
			font-size: 3rem;
			text-align: center;

			.currency {
				font-size: 1rem;
			}
		}

		.features {
			margin: 0 25px;
			min-height: 320px;
			padding-top: 10px;

			.features-item {
				display: flex;
				justify-content: space-between;
				padding: 10px;
				border-bottom: 1px solid rgba(122, 122, 122, 0.298);
				color: #7a7a7a;
				font-size: 0.9rem;
				transition: all 0.3s;
				cursor: pointer;

				.selected {
					border: 1px solid blue;
				}

				&:hover {
					color: #fff !important;
					background-color: #4d306e;
				}
			}
		}
	}
</style>